export default {
  meta: {
    title: '模版管理-配置类目',
  },
};
